<p-blockUI [blocked]="blocked">
  <div id="center">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>

<p-panel header="Sample Placement" [toggleable]="true">
    <div class="mt-1 mx-0 grid justify-content-between h-full">
        <button (click)="showPlacementView()" class="div-button my-1 px-1 py-2 col-12 text-sm action-button flex flex-row justify-content-center text-primary">
            <div class="font-bold align-content-center py-1 md:text-sm">
                <span class="text-center text-lg md:text-md sm:text-md word-break">Place samples</span>
            </div>
          </button>
    </div>
</p-panel>

<p-dialog header="Sample Placement" [style]="{'min-width': '50%'}" id="sample-placement-dialog" [draggable]="false" [resizable]="false" [closable]="false" [(visible)]="showView" [modal]="true" position="top" (onHide)="showView = false">
    <div class="grid gap-8 flex justify-content-center">
        <div class="col-4 flex align-items-center">
          <button pButton class="white-space-nowrap p-1 overflow-visible" type="button" label="Plate ID"></button>
          <input pInputText class="p-1 w-9rem" id="sample-placement-plate-input" name="SearchPlate" [(ngModel)]="samplePlacementPlateID" size="10" (keydown.enter)="checkPlateForSamplePlacement()" [disabled]="disableSamplePlacementPlateIDField"/>
          <button pButton class="clear-search-button" icon="fa fa-times" (click)="resetField()"></button>
        </div>
        <div class="col-4 flex align-items-center">
          <input type="text" class="sample-position-display action-button text-primary" [value]="selectedCell" readonly>
          <input pInputText type="text" class="p-1 w-9rem" id="barcode-scanner" placeholder="Scan Barcode" (keydown.enter)="saveBarcode()" [(ngModel)]="scannedBarcode"  [disabled]="isSampleSelectionOn">
        </div>
      </div>
      <div *ngIf="showPlateView" class="col-12 flex align-items-center"id="plate-view">
        <app-grid [sampleBarcodeMap]="sampleBarcodeMap" [plateSamplesMap]="plateSamplesMap" [selectedPlate]="samplePlacementPlate" [selectedCell]="selectedCell" [allowMultiSelect]="isSampleSelectionOn" (selectedGridCells)="setSelectedGridCells($event)" (selectedGridCell)="setSelectedGridCell($event)"></app-grid>
      </div>
      <div class="col-12 d-flex flex-row justify-content-around">
        <div *ngIf="showPlateView" class="col-6 d-flex flex-row justify-content-around">
          <button pButton *ngIf="!isSampleSelectionOn" class="buttonsRound" label="Select Samples" (click)="turnOnSampleSelection()"></button>
          <button pButton *ngIf="isSampleSelectionOn" class="buttonsRound" label="Clear Selection" (click)="turnOffSampleSelection()"></button>
          <button pButton *ngIf="isSampleSelectionOn" class="buttonsRound removeSamples" label="Remove Sample" [disabled]="disableRemoveSamplesButton()" (click)="removeSamples()"></button>
        </div>
        <div class="col-6 d-flex flex-row justify-content-center">
          <button pButton label="Close" icon="fa fa-times" class="buttonsRound" (click)="closePopUp()"></button>
        </div>
      </div>
</p-dialog>


<p-dialog header="Please select a sample" showEffect="fade" position="top" [(visible)]="duplicateSamplesPresent" [modal]="true">
  <app-duplicate-sample-selection [duplicateSamples]="allSelectedSamples" (sampleSelectionEmitter)="selectedSampleFromDuplicate($event)"></app-duplicate-sample-selection>
</p-dialog>

<p-dialog header="Sample Check Failed!" [(visible)]="showSampleCheckFailedDialog" [modal]="true" position="top">
  <div class="col-12 flex sample-check-content">
    <br/>
    <h5> Sample Check failed! </h5>
    <br/>
    <h5> {{ sampleCheckErrorMessage }} </h5>
    <br/>
    <h5> Please set the sample aside. </h5>
    <br/>
  </div>
  <div class="col-12 flex mt-2 add-comment-container">
    <button pButton label="Continue" id="add-comment" (click)="closeSampleCheckFailedDialog()"></button>
  </div>
</p-dialog>